export default "__VITE_ASSET__c709547b__"